import PropTypes from 'prop-types'
import React from 'react'
import { productPropTypes } from 'Types'
import { path } from 'Utils'
import { PAGE_CONTEXT as p } from 'Constants'
import {
  ProductGrid,
  ContentListItem,
  FeatureBlock,
  SlottedProductGrid
} from 'Blocks'
import config from 'Config'

const ProductList = props => {
  const pageName = 'productList'
  const pageSize = config.pagination.productList
  const productsLength = props.products.products.length

  let productGridProps = {
    pageName,
    products: props.products.products.slice(0, pageSize),
    gaEventContext: 'productList Page'
  }

  if (props.products.products.length === 0) {
    return (
      <div className="product-list-wrapper no-search-wrapper">
        <p className="no-search-results">
          {config.locale === 'de'
            ? 'Tut uns leid, Ihre Suche ergab keine Treffer.'
            : 'Sorry, we couldn’t find any exact matches.'}
        </p>
        <p className="no-search-results">
          {config.locale === 'de'
            ? 'Bitte geben Sie nicht auf, entfernen Sie einfach einige Filter, um eine breitere Auswahl angezeigt zu bekommen'
            : 'But don’t give up - simply remove a filter to see more general results.'}
        </p>
      </div>
    )
  }

  if (config.articlesEnabled && props.articles.length) {
    let articleSlots = props.articles.map((article, index) => {
      const { displayTitle, uuid, slug, title } = article
      return config.productList.slots.useContentListItem ? (
        <ContentListItem variant="First" item={article} />
      ) : (
        <FeatureBlock
          {...{
            article,
            key: uuid,
            title,
            buttonLabel: 'Shop The Edit',
            buttonUrl: path(p.ARTICLE, { uuid, slug }),
            displayTitle
          }}
        />
      )
    })

    productGridProps = {
      ...productGridProps,
      slots: articleSlots
    }

    return (
      <div className="product-list-wrapper">
        <SlottedProductGrid {...productGridProps} />
        <ProductGrid
          {...productGridProps}
          products={props.products.products.slice(pageSize, productsLength)}
        />
      </div>
    )
  }

  return (
    <div className="product-list-wrapper">
      <ProductGrid {...productGridProps} products={props.products.products} />
    </div>
  )
}

ProductList.propTypes = {
  articles: PropTypes.array,
  products: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.shape({ ...productPropTypes }))
  })
}

export default ProductList
